import { SkeletonCard } from '../common';
import { PlayerSlot } from './PlayerSlot';

const LINE_PLAYER_COUNTS = [3, 3, 4, 1] as const;

export function PitchBlock() {
  return (
    <SkeletonCard className="h-[462px] px-[22px]">
      <div className="flex flex-col gap-[37px]">
        {LINE_PLAYER_COUNTS.map((count, lineIndex) => (
          <div
            key={lineIndex}
            className={`flex items-center w-full ${
              count === 1 ? 'justify-center' : 'justify-between'
            }`}
          >
            {Array.from({ length: count }).map((_, i) => (
              <PlayerSlot key={i} />
            ))}
          </div>
        ))}
      </div>
    </SkeletonCard>
  );
}
